// Toggle open/close nav menu
export function navMenuToggle() {
  const body = document.body;
  const burgerButton = document.querySelector(".burger");
  const close = document.querySelector(".c-nav-menu .c-close");
  const navMenu = document.querySelector(".c-nav-menu");

  body.classList.add("nav-menu-closed");

  burgerButton.addEventListener("click", function () {
    body.classList.remove("nav-menu-closed");
    body.classList.add("nav-menu-open");
  });

  close.addEventListener("click", function () {
    body.classList.remove("nav-menu-open");
    body.classList.add("nav-menu-closed");
  });

  navMenu.addEventListener("click", function (event) {
    if (
      event.target.tagName.toLowerCase() !== "a" ||
      (event.target.classList.contains("logo") &&
        body.classList.contains("home"))
    ) {
      body.classList.remove("nav-menu-open");
      body.classList.add("nav-menu-closed");
    }
  });
}

// Scale nav menu content to prevent overflow
export function navMenuScale() {
  var parentHeight = document.querySelector(".c-nav-menu__bottom").clientHeight;
  var menusHeight = document.querySelector(".c-nav-menu__menus").clientHeight;
  var imageHeight = document.querySelector(".c-nav-menu__image").clientHeight;

  if (menusHeight > 0.85 * parentHeight) {
    var scaleRatio = (0.85 * parentHeight) / menusHeight;
    document.querySelector(".c-nav-menu__menus").style.transform =
      "scale(" + scaleRatio + ")";
  } else {
    document.querySelector(".c-nav-menu__menus").style.transform = "scale(1)";
  }

  if (imageHeight > 0.95 * parentHeight) {
    var scaleRatio = (0.95 * parentHeight) / imageHeight;
    document.querySelector(".c-nav-menu__image").style.transform =
      "scale(" + scaleRatio + ")";
  } else {
    document.querySelector(".c-nav-menu__image").style.transform = "scale(1)";
  }
}
